import { render, staticRenderFns } from "./QuizesGrid.vue?vue&type=template&id=36072720"
import script from "./QuizesGrid.vue?vue&type=script&lang=js"
export * from "./QuizesGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports